import { computed } from "vue";
import { useStore } from "vuex";

const useNotas = () => {
  const store = useStore();

  const createNotas = async (obj) => {
    const resp = await store.dispatch("notas/createNotas", obj);
    return resp;
  };
  const editNotas = async (obj) => {
    const resp = await store.dispatch("notas/editNotas", obj);
    return resp;
  };
  const deleteNotas = async (obj) => {
    const resp = await store.dispatch("notas/deleteNotas", obj);
    return resp;
  };
  const getNotas = async () => {
    const resp = await store.dispatch("notas/getNotas");
    return resp;
  };


  return {
    createNotas,
    editNotas,
    deleteNotas,
    getNotas,
    lstNotas: computed(() => store.getters["notas/getNotas"]),    
  };
};

export default useNotas;
